import onClickOutside from 'react-onclickoutside';
import { branch, compose, renderNothing, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import withToggle from '../../../common/hoc/withToggle';
import EcommerceNavigation from './EcommerceNavigation';
import { setEcomTitle } from '../../actions';
import { canUseEcommerce, isBrandOrSingleShopBrand } from '../../../common/helpers/users';

const mapStateToProps = state => ({
  title: state.products.ecomTitle,
  ecommerceIntegrationEnabled: canUseEcommerce(state) && isBrandOrSingleShopBrand(state),
});

const mapDispatchToProps = {
  setEcomTitle,
};

export default compose(
  withToggle('opened', false),
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    handleClickOutside: props => () => {
      if (props.openedIsOn) {
        props.openedOff();
      }
    },
    toggleDropdown: props => () => {
      props.openedToggle();
    },
    onMenuItemClick: props => (title) => {
      props.setEcomTitle(title);
      props.openedOff();
    },
  }),
  branch(
    props => !props.ecommerceIntegrationEnabled,
    renderNothing,
  ),
  onClickOutside
)(EcommerceNavigation);
